module.exports = function() {
  return new Worker(__webpack_public_path__ + "89edc4bcd894ba29f8a4.worker.js");
};